var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategorySearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_375",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_375)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.5 19.5V13.0385H9.9615V19.5H3.5ZM4.5 18.5H8.9615V14.0385H4.5V18.5ZM7.61525 8.99996L11.7308 2.23071L15.8462 8.99996H7.61525ZM9.35775 7.99996H14.1038L11.7308 4.19621L9.35775 7.99996ZM22.1135 21.8345L19.502 19.223C19.1903 19.4691 18.8432 19.6602 18.4605 19.7962C18.0778 19.932 17.6679 20 17.2308 20C16.1859 20 15.3029 19.6394 14.5818 18.9182C13.8606 18.197 13.5 17.314 13.5 16.2692C13.5 15.2244 13.8606 14.3414 14.5818 13.6202C15.3029 12.899 16.1859 12.5385 17.2308 12.5385C18.2756 12.5385 19.1586 12.899 19.8798 13.6202C20.6009 14.3414 20.9615 15.2244 20.9615 16.2692C20.9615 16.7025 20.8936 17.1074 20.7577 17.4837C20.6217 17.8599 20.439 18.2038 20.2095 18.5155L22.8212 21.127L22.1135 21.8345ZM17.2303 19C17.9948 19 18.6411 18.736 19.1693 18.2082C19.6974 17.6804 19.9615 17.0342 19.9615 16.2697C19.9615 15.5052 19.6976 14.8589 19.1697 14.3307C18.6419 13.8025 17.9957 13.5385 17.2312 13.5385C16.4668 13.5385 15.8204 13.8024 15.2923 14.3302C14.7641 14.858 14.5 15.5042 14.5 16.2687C14.5 17.0332 14.7639 17.6795 15.2917 18.2077C15.8196 18.7359 16.4658 19 17.2303 19Z",
    fill: "#E96F0C"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategorySearch);
export default __webpack_public_path__ + "static/media/category_search.7194008699c0ac5d2cc46a79caba74c3.svg";
export { ForwardRef as ReactComponent };